import { useState, useEffect, useRef } from "react";

const MAX = 95;
const TICK_INTERVAL = 200; // ms

/**
 * Simulate a progress value increasing over time
 */
export function useSimulatedProgress() {
  const [progress, setProgress] = useState<number>(0);
  const intervalRef = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    let simulatedProgress = progress || 0;

    // Start an interval
    intervalRef.current = setInterval(() => {
      // Stop at max
      if (simulatedProgress >= MAX) {
        clearInterval(intervalRef.current!);
        return;
      }

      // Progress increases slower as it gets closer to max
      simulatedProgress = Math.min(
        MAX,
        simulatedProgress + (Math.random() * 2 + 1) * (1 - simulatedProgress / 100)
      );

      setProgress(Math.min(100, Math.round(simulatedProgress)));
    }, TICK_INTERVAL);

    return () => {
      if (intervalRef.current) clearInterval(intervalRef.current);
    };
  }, []);

  const forceComplete = () => {
    setProgress(100);
    if (intervalRef.current) clearInterval(intervalRef.current);
  };

  const resetProgress = () => {
    setProgress(0);
  };

  return { progress, forceComplete, resetProgress };
}
